import React from 'react';

const dict = {
  buttons: {
    backMedia: 'Zurück zu Medien',
  },
  plugins: {
    links: {
      openInNewTab: 'Link in neuem Tab öffnen',
      deleteLink: 'Löschen',
      editLink: 'Bearbeiten',
      types: {
        'media-link': 'Externer Link',
        'page-link': 'Interner Link',
      },
    },
    media: {
      createNew: 'Neues Medium erstellen',
      selectExisting: 'Medien durchsuchen',
    },
  },
  LinkButton: {
    label: 'Neuen Link erzeugen',
    noOptionsText: 'Keine Inhalte gefunden. Zum Erzeugen bestätigen.',
    loadingText: 'Suche...',
    helperText:
      'Suchen Sie einen existierenden Link oder erstellen Sie einen neuen.',
    draft: 'Entwurf',
    public: 'Öffentlich',
    private: 'Privat',
  },

  PageCreationForm: {
    title: 'Neues Dokument erstellen',
  },
  PageStateDialog: {
    title: 'Seiten Status bearbeiten',
    noTitle: 'Kein Titel',
    stateLabel: 'Status',
    draft: 'Entwurf',
    public: 'Öffentlich',
    private: 'Privat',
    rolesLabel: 'Rolle(n) bearbeiten',
    rolesHelperText:
      'Durch die Rolle(n) wird bestimmte welche Benutzer den Inhalt sehen können.',
  },
  AdminHeader: {
    pages: 'Seiten',
    media: 'Medien',
    users: 'Benutzer*innen',
  },
  notifications: {
    login: {
      success:
        'Hallo {{name}}. Sie haben sich erfolgreich im System angemeldet.',
      failed:
        'Fehler bei der Authentifizierung. Bitte Überprüfen Sie Ihre E-Mail und/oder Ihr Passwort.',
      error: 'Fehler bei der Anmeldung.',
    },
    logout: {
      success: 'Sie wurden erfolgreich abgemeldet.',
      error: 'Fehler beim Abmelden.',
    },
    inviteTokenExpired: 'Ihre Einladung ist abgelaufen.',
    resetTokenExpired:
      'Link ungültig. Bitte lassen Sie sich einen neuen Link zusenden.',
    claimAccountError: 'Fehler bei der Registierung.',
    inviteUser: {
      success: 'Die Einladung wurde an {{email}} gesendet',
      error: 'Fehler beim Senden der Einladung. Bitte versuchen sie es erneut.',
    },
    deleteUser: {
      success: '{{name}} wurde erfolgreich gelöscht.',
      error: 'Fehler beim Löschen des Accounts: {{name}}',
    },
    patchMedia: {
      success: 'Medium erfolgreich aktualisiert.',
    },
    uploadFile: {
      success: 'Datei wurde erfolgreich hochgeladen.',
    },
    createMedia: {
      success: 'Externen Inhalt wurde erfolgreich angelegt.',
    },
    sendPasswordReset: {
      success: 'Wir haben eine E-Mail an {{email}} gesendet.',
      error: 'Fehler beim senden der E-Mail: {{email}}',
    },
    resetPassword: {
      success: 'Password erfolgreich geändert.',
      error: 'Fehler beim Ändern des Passwords.',
    },
  },
  table: {
    dataLabel: 'Einträge',
    found: 'gefunden',
    withSearch: 'mit dem Suchbegriff',
    searchPlaceholder: 'Einträge durchsuchen',
    sortByLabel: 'Nach "{{label}}" sortieren',
    labelRowsPerPage: 'Zeilen pro Seite:',
    nextIconButtonText: 'Nächste Seite',
    backIconButtonText: 'Vorherige Seite',
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}-${to} von ${count !== -1 ? count : `mehr als ${to}`}`,
  },
  Media: {
    Preview: {
      DownloadButton: {
        Tooltip: {
          title: 'Herunterladen',
        },
      },
    },
  },
  media: {
    SelectItemCell: {
      label: 'Auswählen',
    },
    delete: {
      title: 'Medium löschen',
      confirmation: ({ media }) => (
        <React.Fragment>
          Wollen Sie das Medium "{media}" wirklich löschen?
        </React.Fragment>
      ),
    },
    attributes: {
      class: 'Typ',
      title: 'Titel',
      updatedAt: 'Aktualisert am',
      owner: 'Erstellt von',
      state: 'Status',
    },
    create: {
      fileUpload: 'Datei hochladen',
      externalUrl: 'Externen Inhalt einbinden',
      confirm: 'Speichern',
      cancel: 'Abbrechen',
      url: 'Externe URL',
      or: 'oder',
      sourceUnknown: 'Externen Inhalt per URL einbinden.',
      sourceKnown: ({ sourceType }) => (
        <React.Fragment>"{sourceType}"-Inhalt erkannt.</React.Fragment>
      ),
    },
    form: {
      confirm: 'Speichern',
      replace: 'Datei ersetzen',
      tagPlaceholder: 'Ein oder mehrere Tags auswählen',
      tagsTitle: 'Tags',
      draft: 'Entwurf',
      public: 'Öffentlich',
      private: 'Privat',
      infos: 'Informationen',
      viewAccessTitle: 'Sichtbar für',
      input: {
        source: 'Link',
        title: 'Titel',
        copyright: 'Copyright',
        author: 'Autor',
        altText: 'Alt Text',
        roles: 'Rollen',
        access: 'Viewaccess',
        state: 'Status',
      },
    },
    preview: {
      download: 'Herunterladen',
    },
  },
  pages: {
    AdminMedia: {
      MediaCreationForm: {
        title: 'Neues Medium erzeugen',
      },
    },
    state: {
      title: 'Seiten Status bearbeiten',
      noTitle: 'Kein Titel',
      stateTitle: 'Status',
      draft: 'Entwurf',
      public: 'Öffentlich',
      private: 'Privat',
      rolesTitle: 'Rolle(n) bearbeiten',
      rolesHelpText:
        'Durch die Rolle(n) wird bestimmt welche Benutzer den Inhalt sehen können.',
    },
    attributes: {
      type: 'Typ',
      title: 'Titel',
      updatedAt: 'Aktualisert am',
      state: 'Status',
      createdByUserName: 'Erstellt von',
    },
    delete: {
      title: 'Seite löschen',
      confirmation: data => {
        return (
          <React.Fragment>
            Wollen Sie die Seite "{data.page}" wirklich löschen?
          </React.Fragment>
        );
      },
    },
  },
  users: {
    invite: {
      title: 'Neuen Benutzer einladen',
      pending: 'Auf Bestätigung warten',
      email: 'E-Mail-Adresse',
      roles: 'Rolle(n)',
      send: 'Einladung senden',
    },
    table: {
      resendInvite: 'Einladung erneut senden',
    },
    delete: {
      title: 'Benutzer löschen',
      confirmation: ({ user }) => (
        <React.Fragment>
          Wollen sie den Account "{user}" wirklich löschen?
        </React.Fragment>
      ),
    },
    edit: {
      title: 'Benutzer editieren',
      email: email => `E-Mail-Adresse`,
      name: name => `Name`,
      rolesTitle: 'Rolle(n) bearbeiten',
      rolesHelperText:
        'Durch die Rolle(n) wird bestimmte welche Inhalte der Benutzer sehen kann.',
    },
    attributes: {
      status: 'Status',
      name: 'Name',
      email: 'E-Mail-Adresse',
    },
  },
  adminMenu: {
    newPage: 'Die Seite ist noch nicht gespeichert.',
    notSaved: 'Ihre Änderung sind noch nicht gespeichert.',
    saveNew: 'Seite Speichern',
    saveChanges: 'Änderungen Speichern',
    infos: 'Seiteninformationen',
    edit: 'Bearbeiten',
    editState: 'Status bearbeiten',
    logout: 'Logout',
    infosDescription:
      'Alle hier hinzugefügten Informationen werden für SEO und beim Posten in sozialen Medien verwendet.',
    tagsLabel: 'Tags',
    tagsPlaceholder: 'Schlagwort suchen',
    tagsHelperText: 'Neues Schlagwort mit Eingabe bestätigen und erzeugen.',
    description: 'Beschreibung',
    author: 'Autorin(nen)',
    thumbnail: 'Titelbild',
  },
  confirmation: {
    cancel: 'Abbrechen',
    confirm: 'Ok',
    close: 'Schließen',
  },
  forgotPassword: {
    title: 'Password zurücksetzen',
    description:
      'Geben Sie Ihr E-Mail Adresse ein. Wir senden Ihnen einen Link um Ihr Passwort zurückzusetzen.',
    create: 'Password zurücksetzen',
    email: 'E-Mail-Adresse',
    successTitle: ' Bitte überprüfen Sie Ihren Posteingang.',
    successDescription:
      'Wir haben Ihnen eine E-Mail geschickt, um Ihr Passwort zurückzusetzen.',
    successSpam:
      'Keine E-Mail erhalten? Bitte überprüfen Sie ihren Spam-Ordner.',
  },
  login: {
    title: 'Anmelden',
    forgotLink: 'Password vergessen?',
    password: 'Passwort',
    email: 'E-Mail-Adresse',
    submit: 'Anmelden',
  },
  noAccess: {
    title: 'Kein Zutritt',
    description: 'Sie haben keinen Zutritt für diesen Bereich',
  },
  resetPassword: {
    successTitle:
      'Sie haben das Passwort für Ihren Account erfolgreich geändert.',
    successDescription:
      'Wir haben Ihnen einen E-Mail zur Bestätigung gesendet.',
    successLink: ({link}) => <React.Fragment>Sie können sich {link}.</React.Fragment>,
    successLinkText: 'hier anmelden',
    title: 'Neues Password vergeben.',
    description:
      'Bitte füllen Sie dieses Formular aus um ein neues Passwort für Ihren Accounts zu vergeben.',
    email: 'E-Mail-Adresse',
    emailHelperText: 'Die E-Mail-Adresse kann nicht geändert werden.',
    password: 'Passwort',
    passwordHelperText: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    passwordConfirmLabel: 'Passwort bestätigen',
    submit: 'Password ändern',
  },
  signup: {
    successTitle: ({name}) => 
			<React.Fragment>Willkommen {name}. Sie haben Ihren Account aktiviert.</React.Fragment>
		,
    successDescription: ({link}) => <React.Fragment>Sie können sich {link}.</React.Fragment>,
    succesLinkText: 'hier anmelden',
    welcome: 'Willkommen',
    description:
      'Bitte füllen Sie dieses Formular aus um Ihren Account zu aktivieren.',
    email: 'E-Mail-Adresse',
    emailHelperText: 'Die E-Mail-Adresse kann nicht geändert werden.',
    name: 'Vollständiger Name',
    password: 'Passwort',
    passwordHelperText: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    passwordConfirmLabel: 'Passwort bestätigen',
    submit: 'Accounts erstellen',
  },
};

export default dict;
